// extracted by mini-css-extract-plugin
export default {"titleBox":"BlueBoxTitle_titleBox__E1yGM","upper":"BlueBoxTitle_upper__ow8d1"};